import config from '@/config'
import Vue from 'vue'
import Vuex from 'vuex'
import actions from './actions'
import premiums from './data/premiums.js'
import presets from './data/presets.js'
import getters from './getters'
import mutations from './mutations'

import { ALL_IN_ONE_CHAT_PAGE_ID, ALL_IN_ONE_CHAT_THEME_LIST } from '@/constants/all-in-one-chat.js'
import { LIVE_PAGE_ID } from '@/constants/live.js'
import { NTN_PAGE } from '@/constants/ntn.js'
import { ADS_SIMULATOR_PAGE } from '@/constants/adsSimulator.js'
import { NVBB_DROPPOINT_LOCATION_OPTIONS } from '@/constants/nvbb.js'
import { SHOP_THEME_LIST } from '@/constants/shop.js'
import { BEACON_PAGE_LIST } from '@/constants/beacon.js'
import { J_AND_T_PAGE_LIST } from '@/constants/jandt.js'
import { INTENT_TEMPLATE_DATA } from '@/constants/intentTemplate.js'
import { CURRENCIES } from '@/constants/currency.js'
import { MemberType as JuzmatchMemberType } from '@/constants/juzmatch.js'
import lon from './modules/lon'
import userState from './modules/user-state'

Vue.use(Vuex)

export const store = new Vuex.Store({
  state: {
    paymentGateway: [
      {
        value: 'pg001',
        name_th: 'GB Prime Pay',
        name_en: 'GB Prime Pay',
        image: '/static/img/assets/payment/logo_payment_gateway/3.GB Prime Pay.png'
      },
      {
        value: 'pgother',
        name_th: 'Other',
        name_en: 'Other',
        image: '/static/img/assets/payment/logo_payment_gateway/other.png'
      }
    ],
    eWalletForVerify: [
      {
        value: 'ew001',
        name_th: 'Dolfin Wallet',
        name_en: 'Dolfin Wallet',
        image: '/static/img/assets/payment/logo_e_wallet/1.Dolfin Wallet.jpg'
      },
      {
        value: 'ew002',
        name_th: 'TrueMoney Wallet / WeCard',
        name_en: 'TrueMoney Wallet / WeCard',
        image: '/static/img/assets/payment/logo_e_wallet/2.True-money.jpg'
      },
      {
        value: 'ew003',
        name_th: 'ShopeePay (แอร์เพย์)',
        name_en: 'ShopeePay',
        image: '/static/img/assets/payment/logo_e_wallet/3.ShopeePay.jpg'
      },
      {
        value: 'ew004',
        name_th: 'Rabbit LINE Pay',
        name_en: 'Rabbit LINE Pay',
        image: '/static/img/assets/payment/logo_e_wallet/4.Rabbit LINE Pay.png'
      },
      {
        value: 'ew005',
        name_th: 'พร้อมเพย์ อี-วอลเล็ต / G-Wallet',
        name_en: 'G-Wallet',
        image: '/static/img/assets/payment/logo_e_wallet/ewallet.png'
      }
    ],
    bankForVerify: [
      {
        value: '004',
        name_th: 'ธนาคารกสิกรไทย จำกัด (มหาชน)',
        name_en: 'KASIKORNBANK PUBLIC COMPANY LIMITED',
        image: '/static/img/assets/payment/logo_bank/3.png'
      },
      {
        value: '006',
        name_th: 'ธนาคารกรุงไทย จำกัด (มหาชน)',
        name_en: 'KRUNG THAI BANK PUBLIC COMPANY LTD.',
        image: '/static/img/assets/payment/logo_bank/4.png'
      },
      {
        value: '002',
        name_th: 'ธนาคารกรุงเทพ จำกัด (มหาชน)',
        name_en: 'BANGKOK BANK PUBLIC COMPANY LTD.',
        image: '/static/img/assets/payment/logo_bank/2.png'
      },
      {
        value: '025',
        name_th: 'ธนาคารกรุงศรีอยุธยา จำกัด (มหาชน)',
        name_en: 'BANK OF AYUDHYA PUBLIC COMPANY LTD.',
        image: '/static/img/assets/payment/logo_bank/14.png'
      },
      {
        value: '014',
        name_th: 'ธนาคารไทยพาณิชย์ จำกัด (มหาชน)',
        name_en: 'SIAM COMMERCIAL BANK PUBLIC COMPANY LTD.',
        image: '/static/img/assets/payment/logo_bank/8.png'
      },
      {
        value: '011',
        name_th: 'ธนาคารทหารไทยธนชาต จำกัด (มหาชน)',
        name_en: 'TMBTHANACHART BANK PUBLIC COMPANY LIMITED',
        image: '/static/img/assets/payment/logo_bank/7.png'
      },
      {
        value: '030',
        name_th: 'ธนาคารออมสิน',
        name_en: 'GOVERNMENT SAVINGS BANK',
        image: '/static/img/assets/payment/logo_bank/18.png'
      },
      {
        value: '024',
        name_th: 'ธนาคารยูโอบี จำกัด (มหาชน)',
        name_en: 'UNITED OVERSEAS BANK (THAI) PUBLIC COMPANY LIMITED',
        image: '/static/img/assets/payment/logo_bank/13.png'
      },
      {
        value: '033',
        name_th: 'ธนาคารอาคารสงเคราะห์',
        name_en: 'THE GOVERNMENT HOUSING BANK',
        image: '/static/img/assets/payment/logo_bank/21.png'
      },
      {
        value: '022',
        name_th: 'ธนาคารซีไอเอ็มบี ไทย จำกัด (มหาชน)',
        name_en: 'CIMB THAI BANK PUBLIC COMPANY LIMITED',
        image: '/static/img/assets/payment/logo_bank/11.png'
      },
      {
        value: '017',
        name_th: 'ธนาคารซิตี้แบงก์ เอ็น.เอ.',
        name_en: 'CITIBANK, N.A.',
        image: '/static/img/assets/payment/logo_bank/36.png'
      },
      {
        value: '032',
        name_th: 'ธนาคารดอยซ์แบงก์',
        name_en: 'DEUTSCHE BANK AG.',
        image: '/static/img/assets/payment/logo_bank/20.png'
      },
      {
        value: '066',
        name_th: 'ธนาคารอิสลามแห่งประเทศไทย',
        name_en: 'ISLAMIC BANK OF THAILAND',
        image: '/static/img/assets/payment/logo_bank/37.png'
      },
      {
        value: '069',
        name_th: 'ธนาคารเกียรตินาคินภัทร จำกัด (มหาชน)',
        name_en: 'KIATNAKIN PHATRA BANK PUBLIC COMPANY LIMITED',
        image: '/static/img/assets/payment/logo_bank/28.png'
      },
      {
        value: '073',
        name_th: 'ธนาคารแลนด์ แอนด์ เฮ้าส์ จำกัด (มหาชน)',
        name_en: 'LAND AND HOUSES BANK PUBLIC COMPANY LIMITED',
        image: '/static/img/assets/payment/logo_bank/31.png'
      },
      {
        value: '039',
        name_th: 'ธนาคารมิซูโฮ จำกัด สาขากรุงเทพฯ',
        name_en: 'MIZUHO BANK, LTD. BANGKOK BRANCH',
        image: '/static/img/assets/payment/logo_bank/24.png'
      },
      {
        value: '020',
        name_th: 'ธนาคารสแตนดาร์ดชาร์เตอร์ด (ไทย) จำกัด (มหาชน)',
        name_en: 'STANDARD CHARTERED BANK (THAI) PUBLIC COMPANY LIMITED',
        image: '/static/img/assets/payment/logo_bank/10.png'
      },
      {
        value: '018',
        name_th: 'ธนาคารซูมิโตโม มิตซุย แบงกิ้ง คอร์ปอเรชั่น',
        name_en: 'SUMITOMO MITSUI BANKING CORPORATION',
        image: '/static/img/assets/payment/logo_bank/9.png'
      },
      {
        value: '071',
        name_th: 'ธนาคารไทยเครดิต เพื่อรายย่อย จำกัด (มหาชน)',
        name_en: 'THE THAI CREDIT RETAIL BANK PUBLIC COMPANY LIMITED',
        image: '/static/img/assets/payment/logo_bank/30.png'
      },
      {
        value: '067',
        name_th: 'ธนาคารทิสโก้ จำกัด (มหาชน)',
        name_en: 'TISCO BANK PUBLIC COMPANY LIMITED',
        image: '/static/img/assets/payment/logo_bank/27.png'
      },
      {
        value: '662',
        name_th: 'ธนาคารร่วมพัฒนา จำกัด',
        name_en: 'JOINT DEVELOPMENT BANK LIMITED',
        image: '/static/img/assets/payment/logo_bank/1.png'
      },
      {
        value: '008',
        name_th: 'ธนาคารเจพีมอร์แกน เชส',
        name_en: 'JPMORGAN CHASE BANK, NATIONAL ASSOCIATION',
        image: '/static/img/assets/payment/logo_bank/5.png'
      },
      {
        value: '009',
        name_th: 'ธนาคารโอเวอร์ซี-ไชนีสแบงกิ้งคอร์ปอเรชั่น จำกัด',
        name_en: 'OVER SEA-CHINESE BANKING CORPORATION LIMITED',
        image: '/static/img/assets/payment/logo_bank/6.png'
      },
      {
        value: '023',
        name_th: 'ธนาคารอาร์ เอช บี จำกัด',
        name_en: 'RHB BANK BERHAD',
        image: '/static/img/assets/payment/logo_bank/12.png'
      },

      {
        value: '026',
        name_th: 'ธนาคารเมกะ สากลพาณิชย์ จำกัด (มหาชน)',
        name_en: 'MEGA  INTERNATIONAL COMMERCIAL BANK PUBLIC COMPANY LIMITED',
        image: '/static/img/assets/payment/logo_bank/15.png'
      },
      {
        value: '027',
        name_th: 'ธนาคารแห่งอเมริกาเนชั่นแนลแอสโซซิเอชั่น',
        name_en: 'BANK OF AMERICA, NATIONAL ASSOCIATION',
        image: '/static/img/assets/payment/logo_bank/16.png'
      },
      {
        value: '029',
        name_th: 'ธนาคารอินเดียนโอเวอร์ซีส์',
        name_en: 'INDIAN OVERSEA BANK',
        image: '/static/img/assets/payment/logo_bank/17.png'
      },
      {
        value: '031',
        name_th: 'ธนาคารฮ่องกงและเซี่ยงไฮ้แบงกิ้งคอร์ปอเรชั่น จำกัด',
        name_en: 'THE HONGKONG AND SHANGHAI BANKING CORPORATION LTD.',
        image: '/static/img/assets/payment/logo_bank/19.png'
      },
      {
        value: '034',
        name_th: 'ธนาคารเพื่อการเกษตรและสหกรณ์การเกษตร',
        name_en: 'BANK FOR AGRICULTURE AND AGRICULTURAL COOPERATIVES',
        image: '/static/img/assets/payment/logo_bank/22.png'
      },
      {
        value: '035',
        name_th: 'ธนาคารเพื่อการส่งออกและนำเข้าแห่งประเทศไทย',
        name_en: 'EXPORT-IMPORT BANK OF THAILAND',
        image: '/static/img/assets/payment/logo_bank/23.jpg'
      },

      {
        value: '045',
        name_th: 'ธนาคารบีเอ็นพี พารีบาส์',
        name_en: 'BNP PARIBAS',
        image: '/static/img/assets/payment/logo_bank/25.png'
      },
      {
        value: '052',
        name_th: 'ธนาคารแห่งประเทศจีน (ไทย) จำกัด (มหาชน)',
        name_en: 'BANK OF CHINA (THAI) PUBLIC COMPANY LIMITED',
        image: '/static/img/assets/payment/logo_bank/26.png'
      },
      {
        value: '070',
        name_th: 'ธนาคารไอซีบีซี (ไทย) จำกัด (มหาชน)',
        name_en: 'INDUSTRIAL AND COMMERCIAL BANK OF CHINA (THAI) PUBLIC COMPANY LIMITED',
        image: '/static/img/assets/payment/logo_bank/29.png'
      },

      {
        value: '079',
        name_th: 'ธนาคารเอเอ็นแซด (ไทย) จำกัด (มหาชน)',
        name_en: 'ANZ BANK (THAI) PUBLIC COMPANY LIMITED',
        image: '/static/img/assets/payment/logo_bank/32.png'
      },
      {
        value: '080',
        name_th: 'ธนาคารซูมิโตโม มิตซุย ทรัสต์ (ไทย) จำกัด (มหาชน)',
        name_en: 'SUMITOMO MITSUI TRUST BANK (THAI) PUBLIC COMPANY LIMITED',
        image: '/static/img/assets/payment/logo_bank/33.jpg'
      },
      {
        value: '098',
        name_th: 'ธนาคารพัฒนาวิสาหกิจขนาดกลางและขนาดย่อมแห่งประเทศไทย',
        name_en: 'SMALL AND MEDIUM ENTERPRISE DEVELOPMENT BANK OF THAILAND',
        image: '/static/img/assets/payment/logo_bank/34.jpg'
      }
    ],
    metaVerifySlip: [],
    socialChannelOptions: [
      {
        value: 'fb',
        fullValue: 'facebook',
        fullValueForUse: 'facebook',
        text: 'Facebook',
        icon: 'fab fa-facebook',
        color: '#3b5998'
      },
      {
        value: 'line',
        fullValue: 'line',
        fullValueForUse: 'line',
        text: 'Line',
        icon: 'fab fa-line',
        color: '#00c300'
      },
      {
        value: 'ig',
        fullValue: 'instagram',
        fullValueForUse: 'instagram',
        text: 'Instagram',
        icon: 'fab fa-instagram',
        color: '#c13584'
      },
      {
        value: 'webchat',
        fullValue: 'webchat',
        fullValueForUse: 'webchat',
        text: 'Web Chat',
        icon: 'fas fa-globe',
        color: '#e3415a'
      },
      {
        value: 'app',
        fullValue: 'app',
        fullValueForUse: 'app',
        text: 'App Chat',
        icon: 'fas fa-mobile-alt',
        color: '#9cc3c3'
      },
      {
        value: 'ms_team',
        fullValue: 'microsoft teams',
        fullValueForUse: 'ms_team',
        text: 'Microsoft Teams',
        icon: 'fas fa-brands fa-windows',
        color: '#7B83EB'
      },
      {
        value: 'whatsapp',
        fullValue: 'whatsapp',
        fullValueForUse: 'whatsapp',
        text: 'WhatsApp',
        icon: 'fab fa-whatsapp',
        color: '#25d366'
      }
    ],
    edittingIntent: [],
    botStatus: false,
    loading: false,
    newcomer: Vue.localStorage.get('newcomer') === 'true',
    facebook_name: Vue.localStorage.get('facebook_name')
      ? Vue.localStorage.get('facebook_name')
      : Vue.localStorage.get('userid'),
    isLoggedIn: !!Vue.localStorage.get('token'),
    isFacebook: Vue.localStorage.get('FB') === 'true',
    isSelectedBot: !!Vue.localStorage.get('selectedBot'),
    selectedBot:
      Vue.localStorage.get('selectedBot') && Vue.localStorage.get('selectedBot') !== 'undefined'
        ? JSON.parse(Vue.localStorage.get('selectedBot'))
        : [],
    userid: Vue.localStorage.get('userid'),
    botlist:
      Vue.localStorage.get('botlist') && Vue.localStorage.get('botlist') !== 'undefined'
        ? JSON.parse(Vue.localStorage.get('botlist'))
        : [],
    pagelist:
      Vue.localStorage.get('pagelist') && Vue.localStorage.get('pagelist') !== 'undefined'
        ? JSON.parse(Vue.localStorage.get('pagelist'))
        : [],
    accessToken: Vue.localStorage.get('token'),
    fbAccessToken: Vue.localStorage.get('fbtoken'),
    openSidebar: true,
    paypalTrackingId: Vue.localStorage.get('paypalTrackingId'),
    setting: undefined,
    welcomeMessage: undefined,
    showModalWelcome: Vue.localStorage.get('showModalWelcome'),
    theme: config.theme,
    chatbot: {
      intentGroup: undefined
    },
    loginChannel: ['facebook', 'account', 'chat2pay'].includes(Vue.localStorage.get('loginChannel'))
      ? Vue.localStorage.get('loginChannel')
      : 'facebook',
    fbScope: Vue.localStorage.get('fbScope'),
    tutoriallist: [],
    alert:
      Vue.localStorage.get('alerts') && Vue.localStorage.get('alerts') !== 'undefined'
        ? JSON.parse(Vue.localStorage.get('alerts'))
        : [],
    partner_code: Vue.localStorage.get('partner_code')
      ? Vue.localStorage.get('partner_code')
      : undefined,
    pageBU: ['114743896611281', '132880665271'],
    specialpage: [
      '274108073649',
      '619202881423565',
      '2261615673888062',
      '1231805606976542',
      '1493632560856869',
      '2105726733070683',
      '391365474996527',
      '282419538600861',
      '229446640739626',
      '229777340553912',
      '1422119811377985',
      '1441887002726565',
      '367229174088451',
      '2244102365841101'
    ],
    pageRussianRoulette: ['101900391252252', '582769212229333'],
    lineimagemapbypageid: [
      '102074341651763',
      '109547317606650',
      '394274810994296',
      '355634702145095',
      '105479814959388',
      '105077088474056', //Foodguru test
      '1192315994209757', //Foodguru
      '100339565610749',
      '102370245472711', // Test Lamy
      '2037301563028410', //Lamy
      '106858277640083',
      '102126962268028', //Test Prudential
      '110807598418528'
    ],
    livepage: LIVE_PAGE_ID,
    linenotifylist: [],
    ecommerce: {
      products: [],
      loadingProduct: true,
      categories: [],
      loadingCategory: true,
      charges: {},
      loadingCharges: true
    },
    loadingUserStatus: true,
    userStatus: [],
    loadingSetting: true,
    groupConversation: [],
    loadingGroupConversation: true,
    linePushMessageCount: null,
    loadingLinePushMessageCount: true,
    uuAreaName: [
      'ประปาบางปะกง',
      'ประปาฉะเชิงเทรา',
      'ประปาบ่อวิน',
      'ประปาหนองขาม',
      'ประปาสัตหีบ',
      'ประปาระยอง',
      'ประปานครสวรรค์',
      'ประปาหัวรอ',
      'ประปาเทศบาลพระนครศรีอยุธยา',
      'ประปาเทศบาลเมืองตาคลี',
      'นอกพื้นที่บริการ'
    ],
    livechatPageList: ALL_IN_ONE_CHAT_THEME_LIST,
    showSession: ['111895158162143', '157333504139024'],
    pageListSingGaling: ['100856422547014', '352145869189954'],
    pageListCityfresh: ['105432182130709', '462339517184685'],
    livechatPageIdList: ALL_IN_ONE_CHAT_PAGE_ID,
    beaconPageIdList: BEACON_PAGE_LIST,
    exportProduct: ['998122266996445', '104750531515506'],
    livechat: {
      pageid: null,
      app: 'facebook',
      type: 'bot',
      loadMonth: 1,
      currentLoadMonth: 1,
      userlist: {
        admin: {
          offset: 0,
          loading: false,
          limit: 20,
          users: [],
          isAutoRefresh: true,
          hasMore: true,
          hasNew: false
        },
        bot: {
          offset: 0,
          loading: false,
          limit: 20,
          users: [],
          isAutoRefresh: true,
          hasMore: true,
          hasNew: false
        }
      },
      monobopages: [
        '148831989096546',
        '1229692217050821',
        '135565533158593',
        '488563718210335',
        '799590883441878'
      ],
      currentUser: null,
      currentUserTicket: [],
      currentUserTicketLoading: false,
      chatlog: [],
      loadingChatlog: true,
      limitFatchChatlog: 20,
      maxFetchChatlogTime: 120000, // 2 min
      limitFatchUser: 20,
      maxFetchUserTime: 120000, // 2 min,
      maxFetchReadTime: 120000, // 2 min,
      filter: {
        search: '',
        status: null,
        tags: [],
        app: '',
        adminread: null
      },
      tags: []
    },
    modal: {
      input: {},
      component: null,
      open: false,
      width: '600px'
    },
    allSchools: [],
    filter: {
      search: '',
      uuAreaName: '',
      uu_register_status: '',
      lineid: '',
      uu_name: '',
      phoneno: '',
      keyword: ''
    },
    presets: presets.data,
    premiums: premiums.data,
    progress: 0,
    UnlimitedConversation: [
      '100436434784238',
      '103530654454270',
      '1469559653364545',
      '105696154492400',
      '103955724454263', //TestMootest
      '177735408970104'
    ],
    pageProfile: null,
    loadingPageProfile: true,
    shippinglist: [],
    partnerProfile: null,
    loadingPartnerProfile: true,
    ntnPage: NTN_PAGE,
    adsSimulatorPage: ADS_SIMULATOR_PAGE,
    centralPage: [
      '110710877332627',
      '160733491520',
      '107235216024674',
      '394274810994296', //จี้เส้น
      '392612533487',
      '103551424764072',
      '392612533487',
      '11462159325207',
      '114621593252079',
      '134297248716',
      '408054729252920',
      '122424499005',
      '122424499005',
      '408054729252920',
      '122424499005',
      '102421048239798',
      '105928254552462'
    ],
    loadingAgentGroups: false,
    agentGroups: [],
    loadingAgentSubgroups: false,
    agentSubgroups: [],
    loadingAgents: false,
    agents: [],
    admingroupid: Vue.localStorage.get('admingroupid'),
    adminsubgroupid: Vue.localStorage.get('adminsubgroupid'),
    privilege:
      Vue.localStorage.get('privilege') && Vue.localStorage.get('privilege') !== 'undefined'
        ? JSON.parse(Vue.localStorage.get('privilege'))
        : [],
    toapainterpage: ['102915644812388'],
    toacustomerpage: ['102968804806798', '148559413337'],
    toadealerpage: ['102028964902390'],
    toaNewDealerPage: ['109436881553235'],
    toaPaintPage: ['107999415145694', '148559413337'],
    menubypageid: {
      104907684692250: ['comment', 'dashboard']
    },
    supertenpage: ['104665701343082', '154660564561038'],
    kfcpage: ['106855151601601', '102052945584054'],
    facebook_users_name: [],
    subcategory: ['116989963422911', '1775425925847885'],
    livechatadminreadpage: ['394274810994296', '208321456497173', '103267601317473'],
    shoptheme: SHOP_THEME_LIST,
    beavermanpage: ['103003014894231'],
    niveapage: ['133498913379485', '125865357450484'],
    thailandPostmartPage: ['115414076948160', '396306053873110'],
    astonAdmins: [],
    loadingAstonAdmins: false,
    astonCustomerGroup: [
      'อื่นๆ',
      'รอสรุปยอด',
      'ร้องเรียน',
      'เปลี่ยนเบอร์-ที่อยู่',
      'โอนเงิน',
      'สั่งซื้อ',
      'ยกเลิก',
      'สั่งซื้อlive',
      'สนใจ',
      'หลังการขาย',
      'ปัญหา'
    ],
    selectedCom7page: {
      name: 'All',
      pageid: null
    },
    gbprimetheme: ['ecommercebasic', 'seagull'],
    com7pages: [
      {
        name: 'Banana',
        pageid: '126654220708334'
      },
      // {
      //   name: 'Banana test',
      //   pageid: '102954402002193'
      // },
      // {
      //   name: 'Studio7 ', // studio 7 test
      //   pageid: '108971401389284'
      // },
      {
        name: 'Studio7',
        pageid: '346030320266'
      }
      // {
      //   name: 'ustore ',
      //   pageid: '719003198911316'
      // }
    ],
    nestlePages: [
      {
        name: 'Nestle Health Science Thailand',
        pageid: '1037700739663223'
      },
      {
        name: 'Test Nestle',
        pageid: '108234815144840'
      },

      {
        name: 'Test Nestle 2',
        pageid: '101542172593323'
      },
      {
        name: 'Nestle Health Science: Boost TH',
        pageid: '110981841237323'
      }
    ],
    bbqPage: ['200701213291845', '106240318558522', '104767375443976'],
    bbqTestPage: ['106240318558522', '104767375443976'],
    newDeshboard: ['361231620965547'],
    rabbitPage: ['108973710878860', '326180737483767', '101760532365601'],
    rabbitReplyFBPostPage: ['101760532365601', '326180737483767'],
    lamyPage: ['102370245472711', '2037301563028410'],
    oceanlifePage: ['110549014810557', '1541081009538378', '106513498304487'],
    kmbPage: [
      '1564493033773982',
      '113741808333359',
      '320177684506145',
      '100451034838663',
      '203791699489961',
      '317796734758919'
    ],
    toacrmrewardcategories: [],
    toacrmbranch: [],
    toacrmpointdata: {},
    toacrmProductName: [],
    toacrmProductMarketing: [],
    toacrmProductSubMarketing: [],
    toaEcouponStore: [],
    toaEcouponProducts: [],
    toaEcouponRewardCategories: [],
    toaEcouponCampaigns: [],
    toaEnableCampaignList: [],
    newchatnotify: {},
    iccpage: [
      '103669308635970',
      '101294872210698',
      '102944058709341',
      '102054622133230',
      '107898204895323',
      '182366355126026',
      '135625339853652',
      '103669308635970',
      '236020493215058',
      '347753078624',
      '104845608724391',
      '110218459027409'
    ],
    prudentialPage: ['102126962268028'],
    prudentialRealPage: ['111901618984646'],
    powerbuyTest: ['105344925152387'],
    gpfPage: ['106004118709627'],
    ticketPageid: [
      '106004118709627',
      '104337274602594',
      '100260714951032',
      '495271297476302',
      '105017609020919',
      '1637674519806774',
      '113282044961669',
      '103238152679894',
      '110614952012250',
      '178316699484910',
      '102901306098188',
      '108875962319819', // Test Ratchathani Leasing
      '1688468514708248'
    ],
    ticketThemeList: ['seagull'],
    toacrmproducts: [],
    delayImportUserTime:
      Vue.localStorage.get('delayImportUserTime') &&
      Vue.localStorage.get('delayImportUserTime') !== 'undefined'
        ? JSON.parse(Vue.localStorage.get('delayImportUserTime'))
        : [],

    intents: undefined,
    loadingIntents: true,
    selectToaCampaign: null,
    rabbitSelectedPostId: null,
    status: undefined,
    tags: undefined,
    beaconMasterData: {
      groupAudience: [],
      beaconBranch: []
    },
    hopinnMasterData: {
      position: [],
      affiliation: []
    },
    gpfBuddyMasterData: {
      company: [],
      workGroup: [],
      department: [],
      position: []
    },
    juzMatchMasterDataCrm: [
      { id: 'All', name: 'ทั้งหมด' },
      {
        id: JuzmatchMemberType.Investor,
        name: 'นักลงทุน'
      },
      {
        id: JuzmatchMemberType.Buyer,
        name: 'ผู้เช่าซื้อ'
      },
      {
        id: JuzmatchMemberType.VipInvestor,
        name: 'นักลงทุน (VIP)'
      },
      {
        id: JuzmatchMemberType.VipBuyer,
        name: 'ผู้เช่าซื้อ (VIP)'
      }
    ],
    juzMatchMasterDataSale: [
      { id: 'All', name: 'ทั้งหมด' },
      {
        id: JuzmatchMemberType.Investor,
        name: 'สนใจลงทุน'
      },
      {
        id: JuzmatchMemberType.Buyer,
        name: 'สนใจเช่าซื้อ'
      },
      {
        id: JuzmatchMemberType.Seller,
        name: 'ฝากขายทรัพย์'
      }
    ],
    tremendousMasterData: {
      branch: []
    },
    lamyFilterProductMasterData: {
      categories: [],
      colours: [],
      headtypes: [],
      models: [],
      product_names: [],
      sizes: [],
      branch: []
    },
    rootsMasterData: {
      company: []
    },
    bbqStatusColor: null,
    powerbuyBranchList: [],
    powerbuyMainBranch: null,
    defaultBubbleList: [
      'text',
      'button',
      'image',
      'multiple_image',
      'generic',
      'meta_pay',
      'video',
      'welcome_message',
      'line_flex',
      'rich_message',
      'line_imagemap',
      'line_sticker',
      'payment_form',
      'add_cart',
      'ntn_template'
    ],
    generaliGameSetting: null,
    ticketTags: null,
    ticketTagsFull: null,
    ticketTagsPageId: null,
    nvbbDroppointLocationOptions: NVBB_DROPPOINT_LOCATION_OPTIONS,
    jAndTPage: J_AND_T_PAGE_LIST,
    intentTemplateData: INTENT_TEMPLATE_DATA,
    selectedAutoTraining: [],
    selectConversationAutoTrainingID: '',
    tcpSubpages: null,
    chatConfig: null,
    funnel: {
      currentUser: null,
      showUser: false
    },
    wrapUp: undefined,
    snackbar: {
      show: false,
      text: '',
      color: 'info'
    },
    tcpMasterData: {
      memberLevel: []
    },
    botProfile: {
      data: undefined,
      total: 0
    },
    countAgentStatus: null,
    countAgentStatusTimer: null,
    currencies: CURRENCIES,
    admin: undefined
  },
  getters,
  mutations,
  actions,
  modules: {
    lon,
    userState
  }
})



// WEBPACK FOOTER //
// ./src/store/store.js